import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faFileEdit, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { ChangeEvent, useEffect, useState } from "react";
import { jdlResultProps } from "../../../utils/types";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { GET_ARCHIVE_JDL_END_POINT, CONNECT_SPREAD_SHEET_END_POINT } from "../../../config/config";
import UpdateRequirements from "../modal/jdl-modals/published-archives/UpdateRequirement";
import DeleteJdl from "../modal/jdl-modals/published-archives/deleteJdl";
import Modal from "../modal/modal";
import { SET_JDL_PUBLISH_STAT_END_POINT } from "../../../config/config";
import { Notification } from "../pop-ups/notification";
import { AxiosError } from "axios";

export default function Archive (){

    const [archives, setArchives] = useState<jdlResultProps[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalChildren, setModalChildren] = useState<React.JSX.Element | null>(null);
    const [showNotif, setShowNotif] = useState<boolean>(false);
    const [notifValue, setNotifValue] = useState<string>('');
    const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
    const [multipleIds, setMultipleIds] = useState<number[]>([]);
    const [selectAll, setSelectAll] = useState<boolean>(false)
    const [search, setSearch] = useState('');
    const [dataIsLoading, setDataIsLoading] = useState<boolean>(true); 

    function handleSearch (e : ChangeEvent<HTMLInputElement>){
        setSearch(e.target.value);
    }

    const jdlData = archives.filter((data)=>
        data.position_title.toLowerCase().includes(search.toLowerCase()) ||
        data.client_name.toLowerCase().includes(search.toLowerCase()) ||
        data.domain_name.toLowerCase().includes(search.toLowerCase()) ||
        data.segment_name.toLowerCase().includes(search.toLowerCase()) ||
        data.segment_name.toLowerCase().includes(search.toLowerCase()) ||
        data.status.toLowerCase().includes(search.toLowerCase())
    );
    
    function createModalContent(content : React.JSX.Element){
        setModalChildren(content);
        setShowModal(true);
    }

    function selectAllJdlArchives (e : ChangeEvent<HTMLInputElement>){
        setSelectAll(e.target.checked);
        setArchives(archives.map((item: jdlResultProps) => ({...item, checked: e.target.checked})));
        
        if(e.target.checked){
            setMultipleIds(archives.map(item => item.id))
        }else{
            setMultipleIds([])
        }
    }

    function handleSelectItem (id : number, e : ChangeEvent<HTMLInputElement>){
        const newData = archives.map((item: jdlResultProps) => 
            item.id === id ? {...item, checked: e.target.checked} : item)

        setArchives(newData);

        const selectedIds = newData.filter(item => item.checked).map(item => item.id);
        setMultipleIds(selectedIds);

        const allChecked = newData.every(item => item.checked);
        setSelectAll(allChecked);

        if(!newData.some(item => item.checked)) setMultipleIds([]);
    }

    useEffect(()=>{
        async function getArchives () {
            try{
                const archivesJdl = await api.get(GET_ARCHIVE_JDL_END_POINT, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                const data = archivesJdl.data
                setArchives(data.map((item: jdlResultProps) => ({...item, checked: false})));
                setSelectAll(false);
                setMultipleIds([])
                setDataIsLoading(false);
            }catch(e){
                setDataIsLoading(false);
            }
        }
        getArchives();
    }, [isSuccess, showModal])

    function publishJdl (id : number){
        setShowNotif(true);
        setNotifValue('Processing....');

        setTimeout(async()=>{
            try{
                await api.patch(SET_JDL_PUBLISH_STAT_END_POINT, {
                    id : [id],
                    publish_stat : 'Yes'
                },{
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setIsSuccess(true);
                setNotifValue('JDL set uploaded!');
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    setIsSuccess(false);
                    setNotifValue('Unauthorized access!')
                }else{
                    setIsSuccess(false);
                    setNotifValue('An error occured!')
                }
            }
            
            setTimeout(()=>{
                setIsSuccess(null)
                setShowNotif(false)
            },1000)    
        }, 500)
    }

    function publishAllJdl (){
        setShowNotif(true);
        setNotifValue('Processing....');

        setTimeout(async()=>{
            try{
                await api.patch(SET_JDL_PUBLISH_STAT_END_POINT, {
                    id : multipleIds,
                    publish_stat : 'Yes'
                },{
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setIsSuccess(true);
                setNotifValue('JDL Uploaded!');
                setMultipleIds([]);
                setSelectAll(false);
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    setIsSuccess(false);
                    setNotifValue('Unauthorized access!')
                }else{
                    setIsSuccess(false);
                    setNotifValue('An error occured!')
                }
            }
            
            setTimeout(()=>{
                setIsSuccess(null)
                setShowNotif(false)
            },1000)    
        }, 500)
    }

    const appendToSpreadSheet = () => {
        setShowNotif(true);
        setNotifValue('Processing....');

        setTimeout(async()=>{
            try{
                await api.post(CONNECT_SPREAD_SHEET_END_POINT, {
                    id : multipleIds
                },{
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setIsSuccess(true);
                setNotifValue('JDL transfered to spreadsheet!');
                setMultipleIds([]);
                setSelectAll(false);
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    setIsSuccess(false);
                    setNotifValue('Unauthorized access!')
                }else{
                    setIsSuccess(false);
                    setNotifValue('An error occured!')
                }
            }
            
            setTimeout(()=>{
                setIsSuccess(null)
                setShowNotif(false)
            },1000)    
        }, 500)
    }

    return (
        <div>
            <div className="w-full bg-white px-2 py-4">
                <h1 className="text-md">
                    Import to ERS
                </h1>
            </div>
            <div className="w-full flex items-center bg-white px-2 py-4">
                <div className={multipleIds.length > 0 ? "flex justify-center items-center gap-4" : "hidden"}>
                    <div>
                        <button type="button" onClick={publishAllJdl} className="button button-vcc-blue text-sm">
                            <FontAwesomeIcon icon={faUpload} />&nbsp;
                            Set uploaded
                        </button>
                    </div>
                    <div>
                        <button type="button" onClick={() => createModalContent(<DeleteJdl id={multipleIds} name="" />)} className="button button-danger text-sm">
                            <FontAwesomeIcon icon={faTrashAlt} />&nbsp;
                            Delete All
                        </button>
                    </div>
                    <div>
                        <button type="button" onClick={appendToSpreadSheet} className="button button-vcc-green text-sm">
                            <FontAwesomeIcon icon={faFileExcel} />&nbsp;
                            Save to spreadsheet
                        </button>
                    </div>
                </div>
                <div className="ms-auto">
                    <input type="text" onChange={handleSearch} value={search} className='text-box' placeholder="Search to upload...." />
                </div>
            </div>
            <div className='max-h-96 max-w-full overflow-y-auto overflow-x-auto hide-scrollbar border bg-white'>
                <table className="w-full border">
                    <thead className="table-fixed-header border">
                            <tr>
                                <th className='table-headers'>
                                    <div>
                                        <input type="checkbox" checked={selectAll} onChange={selectAllJdlArchives} className="check-box" />
                                    </div>
                                </th>
                                <th className='table-headers'>Position Title</th>
                                <th className='table-headers'>Client</th>
                                <th className='table-headers'>Domain</th>
                                <th className='table-headers'>Segment</th>
                                <th className='table-headers'>Sub-Segment</th>
                                <th className='table-headers'>Status</th>
                                <th className='table-headers'>Action</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                        {dataIsLoading ? (
                            <>
                                <tr className="">
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                    <td className='table-body'>
                                        <div className="table-loading"></div>
                                    </td>
                                </tr>
                            </>
                        ) : (
                            <>
                                {archives.length > 0 ? (
                                    <>
                                        {jdlData.map((value, index)=>(
                                    <tr className="hover:bg-gray-300">
                                        <td className='table-body px-2'>
                                            <div>
                                                <input type="checkbox" checked={value.checked} onChange={(e) => handleSelectItem(value.id, e)} className="check-box" />
                                            </div>
                                        </td>
                                        <td className='table-body px-2'>{value.position_title}</td>
                                        <td className='table-body px-2'>{value.client_name}</td>
                                        <td className='table-body px-2'>{value.domain_name}</td>
                                        <td className='table-body px-2'>{value.segment_name}</td>
                                        <td className='table-body px-2'>{value.sub_segment_name}</td>
                                        <td className='table-body px-2'>{value.status}</td>
                                        <td className='table-body px-2'>
                                            <div className='flex gap-4 justify-center items-center'>
                                                <i onClick={()=> createModalContent(<UpdateRequirements id={value.id} />)} className="cursor-pointer text-blue-500">
                                                    <FontAwesomeIcon icon={faFileEdit} />
                                                </i>
                                                <i onClick={()=> publishJdl(value.id)} className="cursor-pointer text-gray-600">
                                                    <FontAwesomeIcon icon={faUpload} />
                                                </i>
                                                <i onClick={()=> createModalContent(<DeleteJdl id={[value.id]} name={value.position_title} />)} className="cursor-pointer text-red-500">
                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                </i>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                    </>
                                ) : (
                                    <>
                                        <tr className="hover:bg-gray-300">
                                            <td colSpan={8} className='table-body'>To import roles table is empty.</td>
                                        </tr>
                                    </>
                                )}
                            </>
                        )}
                    </tbody>
                </table>
            </div>
            {showModal &&(
                <Modal onClose={()=>setShowModal(false)}> 
                    {modalChildren}
                </Modal>
            )}
            {showNotif && (
                <Notification notif={notifValue} success={isSuccess} />
            )}
        </div>
    );
}